export default "__VITE_ASSET__CRuJRcqQ__"